import * as Actions from './actions';
import * as SFActions from '../DataServices/SFDataService/actions';

export function opportunityReducer(state = null, action) {
  switch (action.type) {
    case Actions.OPPORTUNITY_DATA_TERMINATE_LOADING:
      return action.opportunity;
    case Actions.OPPORTUNIY_UPDATED:
      return action.opportunity;
    case SFActions.UPDATE_OPPORTUNITY_STORAGE:
      return action.opportunity;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/services/SFOpportunityService/reducers.js